import { portalBackendUrl } from "../config";
import { useAuthentication } from "./AuthenticationContext";
import Logout from "./Logout";
import OAuth2AuthCodeCallback from "./Oauth2AuthCodeCallback";
import type { UserDetails } from "./types";

function getOrganizationSelectionUrl(redirectUrl: string) {
  // the redirect URL carries its own query string, so it has to be encoded —
  // otherwise its params are read as params of the organization selection URL
  return `${portalBackendUrl}/control-panel/portal-frontend/?next=${encodeURIComponent(redirectUrl)}`;
}

export {
  getOrganizationSelectionUrl,
  Logout,
  OAuth2AuthCodeCallback,
  useAuthentication,
  UserDetails,
};
